import { styled } from '@mui/material/styles';
import { default as SimpleButton } from '@mui/material/Button';
import { GradientButtonProps } from '../../helpers/types';


// is this repeated? there is another CustomButton in Button.tsx. We need to keep the other one
export const CustomButton = styled(SimpleButton)<GradientButtonProps>(
  ({ disabled, variant, theme }) => ({
    color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
    background: disabled
      ? theme.palette.action.disabledBackground
      : theme.palette.primary.main,
    textTransform: 'capitalize',
    width: 'fit-content',
    height: 'fit-content',
    '&.MuiButton-root': {
      padding: '5px 13px',
    },
    '&:hover': {
      background: disabled
        ? theme.palette.action.disabledBackground
        : theme.palette.primary.dark,
    },
  }),
);
